import React, { useState } from "react";
import Select, { components } from "react-select";
import { SVGChevronDown, SVGChevronUp } from "@/lib/svg";
import { InputWrapper, ErrorMessage } from "@/lib/styles";
import { DropDownOption, DropDownCheckMark } from "./styles";

/**
 * TODO Allow to control styles using custom props and customStyle prop.
 *
 * Reference:
 * https://github.com/JedWatson/react-select/issues/4804
 * https://react-select.com/styles#select-props
 * https://stackoverflow.com/a/71081394/1498118
 * https://github.com/JedWatson/react-select/issues/5214
 * https://codesandbox.io/s/codesandboxer-example-forked-lui10t?file=/example.tsx
 */

export default function SelectDropdown(props: any) {
  const {
    placeholder = "",
    name = "",
    required = false,
    items = [],
    validErrorText,
    defaultValue = null,
    callBackFn,
    itemId,
    chevronColor,
    overrideStyles
  } = props;

  const icon = (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7072 1.70711C12.0977 1.31658 12.0977 0.683417 11.7072 0.292893C11.3166 -0.0976311 10.6835 -0.0976311 10.293 0.292893L11.7072 1.70711ZM4.00004 8.00002L3.29294 8.70713C3.68346 9.09765 4.31662 9.09765 4.70715 8.70713L4.00004 8.00002ZM1.7071 4.29289C1.31658 3.90237 0.683414 3.90237 0.292891 4.2929C-0.0976323 4.68342 -0.0976299 5.31659 0.292896 5.70711L1.7071 4.29289ZM10.293 0.292893L3.29293 7.29291L4.70715 8.70713L11.7072 1.70711L10.293 0.292893ZM0.292896 5.70711L3.29294 8.70713L4.70715 7.29291L1.7071 4.29289L0.292896 5.70711Z"
        fill="white"
      />
    </svg>
  );

  const [selectedOption, setselectedOption]: any = useState(defaultValue);

  const handleChange = (selectedOption: any) => {
    setselectedOption(selectedOption);

    if (callBackFn) {
      callBackFn(itemId, selectedOption.value);
    }
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <SVGChevronUp width={"16px"} />
        ) : (
          <SVGChevronDown width={"16px"} />
        )}
      </components.DropdownIndicator>
    );
  };

  const Control = ({ children, ...props }: any) => (
    <components.Control className="select-control" {...props}>
      {children}
    </components.Control>
  );

  const Option = ({ children, ...props }: any) => (
    <components.Option className="option" {...props}>
      <DropDownOption className={props.isSelected ? "active" : ""}>
        <DropDownCheckMark>{icon}</DropDownCheckMark>
        {children}
      </DropDownOption>
    </components.Option>
  );

  const Placeholder = ({ children, ...props }: any) => (
    <components.Placeholder className="select-placeholder" {...props}>
      {children}
    </components.Placeholder>
  );

  return (
    <InputWrapper
      onFocus={(e: any) => {
        e.target.closest(".error")?.classList.remove("error");
      }}
      style={{cursor: "pointer"}}
    >
      <input
        style={{display: "none"}}
        type="text"
        name={name}
        value={
          selectedOption && selectedOption?.value ? selectedOption?.value : ""
        }
        required={required}
        readOnly
      />
      <Select
        className="select"
        value={selectedOption}
        onChange={handleChange}
        options={items}
        placeholder={`${placeholder}${required ? "*" : ""}`}
        styles={{...customStyles, ...overrideStyles}}
        components={{
          DropdownIndicator,
          Control,
          Placeholder,
          Option,
        }}
      />
      {required && <ErrorMessage> {validErrorText}</ErrorMessage>}
    </InputWrapper>
  );
}

const customStyles: any = {
  control: () => ({
    border: "none",
    borderBottom: "1px solid #aaaaaa",
    display: "flex",
    paddingBottom: "8px",
    fontFamily: "Lato",
    minHeight: "25px",
  }),
  valueContainer: () => ({
    display: "flex",
    width: "100%",
    color: "#aaaaaa",
    fontSize: "1.25rem",
    paddingLeft: "2px",
    lineHeight: "normal",
  }),
  input: () => ({
    margin: "0",
    padding: "0",
    position: "absolute",
    opacity: "0",
    width: "0",
    height: "0",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: () => ({
    padding: "0",
  }),
  dropdownIndicator: () => ({
    padding: "0",
    position: "absolute",
    right: "0",
  }),
  placeholder: () => ({
    width: "100%",
    minWidth: "100%",
    fontSize: "1.25rem",
    lineHeight: "normal",
  }),
  option: () => ({}),
  menuList: (provided: any) => ({
    ...provided,
    padding: "8px",
  }),
  menu: (provided: any) => ({
    ...provided,
    top: "100%",
    marginTop: "-1px",
  }),
  singleValue: (provided: any) =>({
    ...provided,
    marginLeft: 0,
    marginRight: 0,
  })

};
